import { render } from "./ShowAspectsInfo.vue?vue&type=template&id=592db9f4&scoped=true"
import script from "./ShowAspectsInfo.vue?vue&type=script&lang=js"
export * from "./ShowAspectsInfo.vue?vue&type=script&lang=js"

import "./ShowAspectsInfo.vue?vue&type=style&index=0&id=592db9f4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-592db9f4"]])

export default __exports__